import { Component, OnInit } from '@angular/core';
import { UserDataService } from 'src/app/shared/services/user-data.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  roleId!: string;
  constructor(private userDataService: UserDataService) {}

  ngOnInit(): void {
    this.roleId = this.userDataService.roleId;
  }
}
